(function () {
  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return '/cart/add.js';
  }

  function initSlider(root) {
    var track = root.querySelector('[data-reorder-track]');
    var dotsWrap = root.querySelector('[data-reorder-dots]');
    if (!track || !dotsWrap) return;

    function items() {
      return track.querySelectorAll('[data-reorder-item]');
    }

    function step() {
      var first = items()[0];
      return first ? first.getBoundingClientRect().width : track.clientWidth;
    }

    function pageCount() {
      var size = step();
      if (!size) return 1;
      var perView = Math.max(1, Math.round(track.clientWidth / size));
      return Math.max(1, items().length - perView + 1);
    }

    function currentIndex() {
      var size = step();
      return size ? Math.round(track.scrollLeft / size) : 0;
    }

    function render() {
      var pages = pageCount();
      dotsWrap.hidden = pages <= 1;
      if (dotsWrap.children.length !== pages) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'reorder__dot';
          dot.setAttribute('aria-label', 'Show product ' + (i + 1));
          dot.setAttribute('data-index', String(i));
          dotsWrap.appendChild(dot);
        }
      }
      var active = Math.min(currentIndex(), pages - 1);
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        var isActive = i === active;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    dotsWrap.addEventListener('click', function (event) {
      var dot = event.target.closest('.reorder__dot');
      if (!dot) return;
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollTo({ left: Number(dot.getAttribute('data-index')) * step(), behavior: behavior });
    });

    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        render();
      });
    }, { passive: true });

    window.addEventListener('resize', render);
    render();
  }

  function initReorder(root) {
    root.querySelectorAll('[data-reorder-form]').forEach(function (form) {
      var button = form.querySelector('[data-reorder-add]');
      var errorEl = form.querySelector('[data-reorder-error]');

      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        if (!button || button.getAttribute('aria-busy') === 'true') return;

        var variantId = Number(form.querySelector('[name="id"]').value);
        button.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.hidden = true;

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
              return data;
            });
          })
          .then(function (data) {
            document.body.classList.add('cart-has-items');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: data, addToCartBtn: button }
            }));
          })
          .catch(function (error) {
            if (!errorEl) return;
            errorEl.textContent = error.message;
            errorEl.hidden = false;
          })
          .then(function () {
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-section-type="reorder"]').forEach(function (root) {
      if (root.getAttribute('data-reorder-ready') === 'true') return;
      root.setAttribute('data-reorder-ready', 'true');
      var slider = root.querySelector('[data-reorder-slider]');
      if (slider) initSlider(slider);
      initReorder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
